/**
 * Expiry instant from a JWT `exp` claim, in milliseconds.
 * The backoffice session follows the token instead of a fixed 30 days.
 *
 * @param {string} token - JWT string.
 * @returns {number|null} Epoch milliseconds, or null when `exp` is missing.
 */
export function readJwtExpiryMs(token) {
	try {
		const part = String(token || "").split(".")[1]
		if (!part) return null
		const json = JSON.parse(atob(part.replace(/-/g, "+").replace(/_/g, "/")))
		return typeof json.exp === "number" ? json.exp * 1000 : null
	} catch {
		return null
	}
}
